import wixLocation from 'wix-location';
const mode = "PROD";

console.log('mode', mode);

export const SITE_URL = mode === "PROD" ? 'https://www.wix.com/jobs' : wixLocation.baseUrl; 

export const locationsList = [
    {
        location_title: 'Austin',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'Cedar Rapids',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'Denver',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'Phoenix',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'Los Angeles',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'Miami',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'New York',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'San Francisco',
        email: 'USTA@wix.com'
    },
    {
        location_title: 'Lviv',
        email: 'olenam@wix.com'
    },
    {
        location_title: 'Dnipro',
        email: 'olenam@wix.com'
    },
    {
        location_title: 'Kyiv',
        email: 'olenam@wix.com'
    },
    {
        location_title: 'Vilnius',
        email: 'viltes@wix.com'
    },
    {
        location_title: 'Dublin',
        email: 'chens@wix.com'
    },
    // {
    //     location_title: 'Berlin',
    //     email: 'pazv@wix.com'
    // },
    // {
    //     location_title: 'Sao Paulo',
    //     email: 'pazv@wix.com'
    // },
    {
        location_title: 'London',
        email: 'pazv@wix.com'
    },
    // {
    //     location_title: 'Tokyo',
    //     email: 'pazv@wix.com'
    // },
    //  {
    //     location_title: 'Singapore',
    //     email: 'pazv@wix.com'
    // }
]
